import script from "./leftPie1.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie1.vue?vue&type=script&setup=true&lang=js"

export default script